/*
 * @Descripttion:
 * @version:
 * @Author: gjqiang
 * @Date: 2020-07-27 17:41:35
 */
// 常用状态

export const STATUS_MAP = {
  1: '启用',
  0: '禁用'
}
